 <div class="container border">
    <div class="d-flex justify-content-end">
        <button type="button" mat-button class="fs-3 btn btn-primary" (click)="closePreview()">X</button>
    </div>
    <h4 mat-dialog-title>{{ data.message }}</h4>
    <div mat-dialog-content>
        <div class="row">
            <div class="col-12 mb-3">
                {{description}}
            </div>
        </div>
    </div>
    <div>
        
        @if(isVideo) {
        <video class="video-js" autoplay muted playsinline controls>
            <source [src]="previewUrl" type="{{previewFileType}}">
            Your browser does not support the video tag.
        </video>
        } @else {
        <img [src]="previewUrl"  class="img-fluid img-thumbnail" alt="Preview Image">
        }
    </div>
    <div mat-dialog-actions>
        <button type="button" mat-button class="btn btn-primary" (click)="closePreview()">Close</button>
    </div>
</div>


